import { makeStyles } from 'tss-react/mui';

const useStylesTableStackChartSingleBlock: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme,
): MaterialUIStyles => ({
  tableStackChartSingleBlock: {
    position: 'relative',
    top: -260,
    left: 'calc(35% + 40px)',
    width: '55%',
    [theme.breakpoints.down('sm')]: {
      left: 'calc(35% + 75px)',
      width: '40%',
    },
  },
  tableStackChartSingleBlockEmpty: {
    top: 10,
    left: '5%',
    width: '90%',
  },
}));

export default useStylesTableStackChartSingleBlock;
